import { Language } from './languages';

export const languageMap = {
	[Language.EN]: {
		label: 'EN',
		flag: '🇬🇧',
		name: 'English',
		next: Language.DE,
	},
	[Language.DE]: {
		label: 'DE',
		flag: '🇩🇪',
		name: 'Deutsch',
		next: Language.ES,
	},
	[Language.ES]: {
		label: 'ES',
		flag: '🇪🇸',
		name: 'Español',
		next: Language.FR,
	},
	[Language.FR]: {
		label: 'FR',
		flag: '🇫🇷',
		name: 'Français',
		next: Language.HR,
	},
	[Language.HR]: {
		label: 'HR',
		flag: '🇭🇷',
		name: 'Hrvatski',
		next: Language.IT,
	},
	[Language.IT]: {
		label: 'IT',
		flag: '🇮🇹',
		name: 'Italiano',
		next: Language.LV,
	},
	[Language.LV]: {
		label: 'LV',
		flag: '🇱🇻',
		name: 'Latviešu',
		next: Language.NL,
	},
	[Language.NL]: {
		label: 'NL',
		flag: '🇳🇱',
		name: 'Nederlands',
		next: Language.PL,
	},
	[Language.PL]: {
		label: 'PL',
		flag: '🇵🇱',
		name: 'Polski',
		next: Language.PT,
	},
	[Language.PT]: {
		label: 'PT',
		flag: '🇵🇹',
		name: 'Português',
		next: Language.TR,
	},
	[Language.TR]: {
		label: 'TR',
		flag: '🇹🇷',
		name: 'Türkçe',
		next: Language.EN,
	},
};

export const DEFAULT_LANGUAGE = Language.DE;

export const SUPPORTED_LANGUAGES = Object.keys(languageMap);
